import { ShopOfTheYearNominationCategories } from '../../../../../../types';

export const getSortedCategories = (
  awards: ShopOfTheYearNominationCategories['nodes']
) => {
  return awards
    ? awards
        .filter(award => award)
        .sort((a, b) => {
          if (!a) return 1;
          if (!b) return -1;
          const nameA = a.name ? a.name.toLowerCase() : null;
          const nameB = b.name ? b.name.toLowerCase() : null;
          if (b.mainAward) return 1;
          if (a.mainAward) return -1;
          if (b.isSpecial) return 1;
          if (a.isSpecial) return -1;
          if (!nameA) return 1;
          if (!nameB) return -1;
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        })
    : [];
};
